exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proof-return-dropzone[data-v-244a16cb]{min-height:126px}#proof-return-add-files[data-v-244a16cb]{padding-top:45px}.dz-uploaded-file[data-v-244a16cb]{cursor:default}.dz-uploaded-file .dz-upload-info[data-v-244a16cb]{left:160px}.dz-uploaded-file .dz-progress[data-v-244a16cb]{width:calc(100% - 172px)}", ""]);

// exports
